export default __webpack_public_path__ + "static/media/Y14.ff0ac3ba.jpg";